import {BrowserRouter} from "react-router-dom";
import AppRouter from "./components/AppRouter";
import "./scss/app.scss"
import React, {useContext, useEffect} from "react";
import {Context} from "./index";
import StartPopup from "./components/popups/startPopup";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Toaster} from "sonner";
function App () {

    const {staff} = useContext(Context)
    useEffect(()=>{
        async function fetchData() {
            try {
                await staff.refresh()
            }catch (e) {
                console.log(e)
            }
        }
        fetchData();
        // eslint-disable-next-line
    }, []);
    const queryClient = new QueryClient()


    return (
        <div className="App" >
            <div className="wrapper">
                <QueryClientProvider client={queryClient}>
                    <Toaster  position="top-center" richColors/>
                    <BrowserRouter>
                        <AppRouter/>
                    </BrowserRouter>
                    <StartPopup/>
                </QueryClientProvider>
            </div>
        </div>
    );

}

export default App;
